"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.actionButtonsWrapperClass = exports.rowReverseClass = exports.fileSizeClass = exports.fileNameClass = exports.fontStyleClass = exports.colClass = exports.row = exports.rowClass = exports.progressClass = exports.uploadBarWrapper = exports.buttonWrapper = exports.darkUploadButton = exports.darkThemeRoot = exports.root = void 0;

var _emotion = require("emotion");

var _themeConfig = _interopRequireDefault(require("@lyearn-team/theme-config"));

var root =
/*#__PURE__*/
(0, _emotion.css)("width:100%;display:flex;align-items:center;justify-content:center;border:2px dashed #dee4ee;border-radius:4px;min-height:90px;padding:10px 0;");
exports.root = root;
var darkThemeRoot =
/*#__PURE__*/
(0, _emotion.css)("border-color:", _themeConfig.default.color.dark.sapphire, ";.file-icon{fill:", _themeConfig.default.color.dark.zinc, ";}.file-name,.file-size{font-size:14px;line-height:1.71;color:", _themeConfig.default.color.dark.copper, ";}.action-button{fill:", _themeConfig.default.color.dark.zinc, ";}.preview{align-items:center;}.uploadContainer{align-items:center;.upload-row{.upload-bar{background-color:", _themeConfig.default.color.dark.mars, ";.upload-progress{background-color:", _themeConfig.default.color.dark.sapphire, ";}}.upload-progress-title{font-size:12px;color:", _themeConfig.default.color.dark.copper, ";}}}");
exports.darkThemeRoot = darkThemeRoot;
var darkUploadButton =
/*#__PURE__*/
(0, _emotion.css)("display:flex;flex-direction:column;align-items:center;cursor:pointer;outline:none;.upload-icon{height:24px;width:24px;fill:", _themeConfig.default.color.dark.zinc, ";margin-bottom:12px;}.upload-text{font-size:12px;color:", _themeConfig.default.color.dark.silver, ";}@media (max-width:767px){.upload-icon{width:16px;height:16px;margin-bottom:8px;}}");
exports.darkUploadButton = darkUploadButton;
var buttonWrapper =
/*#__PURE__*/
(0, _emotion.css)("height:44px;");
exports.buttonWrapper = buttonWrapper;

var uploadBarWrapper = function uploadBarWrapper(theme) {
  return (
    /*#__PURE__*/
    (0, _emotion.css)("margin-top:8px;width:100%;max-width:550px;background-color:", theme.color.grey3, ";height:4px;border-radius:40px;")
  );
};

exports.uploadBarWrapper = uploadBarWrapper;

var progressClass = function progressClass(progress, theme) {
  return (
    /*#__PURE__*/
    (0, _emotion.css)("width:", progress, ";height:4px;background-color:", theme.color.accent, ";border-radius:40px;max-width:550px;")
  );
};

exports.progressClass = progressClass;
var rowClass =
/*#__PURE__*/
(0, _emotion.css)("display:flex;flex-direction:row;width:100%;margin-left:12px;position:relative;");
exports.rowClass = rowClass;
var row =
/*#__PURE__*/
(0, _emotion.css)("display:flex;flex-direction:row;width:100%;");
exports.row = row;
var colClass =
/*#__PURE__*/
(0, _emotion.css)("display:flex;flex-direction:column;width:calc(100% - 130px);margin-left:12px;");
exports.colClass = colClass;
var fontStyleClass =
/*#__PURE__*/
(0, _emotion.css)("color:#4a90e2;font-size:12px;font-weight:600;margin-left:12px;");
exports.fontStyleClass = fontStyleClass;

var fileNameClass = function fileNameClass(theme) {
  return (
    /*#__PURE__*/
    (0, _emotion.css)("font-size:14px;color:", theme.color.black1, ";line-height:normal;margin:0;word-break:break-all;")
  );
};

exports.fileNameClass = fileNameClass;

var fileSizeClass = function fileSizeClass(theme) {
  return (
    /*#__PURE__*/
    (0, _emotion.css)("font-size:12px;color:", theme.color.black3, ";letter-spacing:1px;font-weight:600;line-height:normal;margin:0;")
  );
};

exports.fileSizeClass = fileSizeClass;
var rowReverseClass =
/*#__PURE__*/
(0, _emotion.css)("position:absolute;right:18px;");
exports.rowReverseClass = rowReverseClass;
var actionButtonsWrapperClass =
/*#__PURE__*/
(0, _emotion.css)("position:absolute;right:24px;");
exports.actionButtonsWrapperClass = actionButtonsWrapperClass;